// extracted by mini-css-extract-plugin
export var body = "_m7-8";
export var button = "_m7-0";
export var closeButton = "_m7-5";
export var content = "_m7-3";
export var empty = "_m7-f";
export var grid = "_m7-c";
export var header = "_m7-4";
export var icon = "_m7-1";
export var option = "_m7-d";
export var optionSelected = "_m7-e";
export var overlay = "_m7-2";
export var searchIcon = "_m7-a";
export var searchInput = "_m7-b";
export var searchWrapper = "_m7-9";
export var title = "_m7-6";
export var visuallyHidden = "_m7-7";